export interface MenuItem {
  title: string
  icon: string
  to?: string
  children?: MenuItem[]
}

export const useMenuItems = () => {
  const menuItems: MenuItem[] = [
    {
      title: 'Dashboards',
      icon: 'mdi-view-dashboard-outline',
      children: [
        {
          title: 'Analytics',
          icon: 'mdi-chart-line',
          to: '/',
        },
        {
          title: 'eCommerce',
          icon: 'mdi-shopping-outline',
          to: '/analytics',
        },
      ],
    },
    {
      title: 'Apps',
      icon: 'mdi-apps',
      children: [
        {
          title: 'Email',
          icon: 'mdi-email-outline',
          to: '/email',
        },
        {
          title: 'Chat',
          icon: 'mdi-message-outline',
          to: '/chat',
        },
        {
          title: 'Calendar',
          icon: 'mdi-calendar-outline',
          to: '/calendar',
        },
      ],
    },
    {
      title: 'Users',
      icon: 'mdi-account-group-outline',
      to: '/users',
    },
    {
      title: 'Products',
      icon: 'mdi-package-variant-closed',
      to: '/products',
    },
    {
      title: 'Orders',
      icon: 'mdi-shopping-outline',
      to: '/orders',
    },
    {
      title: 'Reports',
      icon: 'mdi-chart-box-outline',
      to: '/reports',
    },
    {
      title: 'Settings',
      icon: 'mdi-cog-outline',
      to: '/settings',
    },
  ]

  return {
    menuItems,
  }
}
